import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import "./App.css";
import "./index.css";
import "./components/common_components/common_css/common_css.css";

import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Sidebar from "./components/sidebar/Sidebar";
import Login_Signup from "./components/login_signup/Login_Signup";
import Verify_Email from "./components/verify_email/Verify_Email";
import Set_New_Password from "./components/set_new_password/Set_New_Password";

import My_Account from "./components/sidebar_components/my_account/My_Account";
import Deposit from "./components/sidebar_components/deposit/Deposit";
import Withdrawal from "./components/sidebar_components/withdrawal/Withdrawal";
import About_Profile from "./components/about_profile/About_Profile";
import Privacy from "./components/privacy/Privacy";
import Risk_Disclosure from "./components/risk_disclosure/Risk_Disclosure";
import Complaints_Handling_Policy from "./components/Complaints_Handling_Policy/Complaints_Handling_Policy";
import Legal_Documents from "./components/legal_documents/Legal_Documents";
import Security_Instructions from "./components/security_instructions/Security_Instructions";
import Preventing_Money_Laundering from "./components/preventing_money_laundering/Preventing_Money_Laundering";
import Transaction_History from "./components/sidebar_components/transaction_history/Transaction_History";
import Market_News from "./components/sidebar_components/market_news/Market_News";
import Performance from "./components/sidebar_components/performance/Performance";
import Settings from "./components/sidebar_components/settings/Settings";
// import Refer_and_Earn from "./components/sidebar_components/refer_and_earn/Refer_and_Earn";

import Trade_Layout from "./components/trade_main/trade_layout/Trade_Layout";

import { Toaster } from 'react-hot-toast';
import Refer_and_Earn from "./components/sidebar_components/refer_and_Earn/Refer_and_Earn";

function App() {
  const location = useLocation();

  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/verify-email" ||
    location.pathname === "/set-new-password";

  const isTradePage = location.pathname === "/trade";

  const showHeader = !isAuthPage;

  return (
    <>
      <ScrollToTop />
      <Toaster position="top-right" />

      {showHeader && <Header />}

      <Routes>
        <Route path="/" element={<Navigate to="/trade" replace />} />
        <Route path="/login" element={<Login_Signup />} />
        <Route path="/verify-email" element={<Verify_Email />} />
        <Route path="/set-new-password" element={<Set_New_Password />} />
      </Routes>

      {!isAuthPage && (
        <div className="body_container">
          {!isTradePage && (
            <section className="dashboard_layout">
              <div className="row">
                <div className="col-xl-2 xl-narrow:col-1 xl-narrow:ps-0 ps-xl-5 col-md-3">
                  <Sidebar />
                </div>

                <div className="col-xl-10 col-lg-12 xl-narrow:col-12 xl-narrow:ps-0 col-md-12 ps-xl-5">
                  <div className="section_box">
                    <Routes>
                      <Route path="/my-account" element={<My_Account />} />
                      <Route path="/deposit" element={<Deposit />} />
                      <Route path="/withdrawal" element={<Withdrawal />} />
                      <Route path="/about-profile" element={<About_Profile />} />
                      <Route path="/privacy-agreement" element={<Privacy />} />
                      <Route path="/risk-disclosure" element={<Risk_Disclosure />} />
                      <Route
                        path="/complaints-handling-policy"
                        element={<Complaints_Handling_Policy />}
                      />
                      <Route path="/legal-documents" element={<Legal_Documents />} />
                      <Route
                        path="/security-instructions"
                        element={<Security_Instructions />}
                      />
                      <Route
                        path="/preventing-money-laundering"
                        element={<Preventing_Money_Laundering />}
                      />
                      <Route
                        path="/transaction-history"
                        element={<Transaction_History />}
                      />
                      <Route path="/market-news" element={<Market_News />} />
                      <Route path="/performance" element={<Performance />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/refer-and-earn" element={<Refer_and_Earn />} />
                    </Routes>

                    <Footer />
                  </div>
                </div>
              </div>
            </section>
          )}

          {isTradePage && (
            <section className="trade_layout_section">
              <Routes>
                <Route path="/trade" element={<Trade_Layout />} />
              </Routes>
            </section>
          )}
        </div>
      )}
    </>
  );
}

export default App;